__turbopack_context__.v({
  "pill": "styles-module__7bPAHG__pill",
  "pillActive": "styles-module__7bPAHG__pillActive",
  "pillLight": "styles-module__7bPAHG__pillLight",
  "pillNoMargin": "styles-module__7bPAHG__pillNoMargin",
});
